module.exports = __webpack_public_path__ + "img/Dantam Hair 16.27570d2b.jpg";